import {
  CUSTOM_ELEMENTS_SCHEMA,
  importProvidersFrom,
  Inject,
  ModuleWithProviders,
  NgModule,
  Optional
} from '@angular/core';

import {FooCommonModule, FooFrameworkModule} from 'foo-framework';

import {NewsBoxComponent} from './news-box/news-box.component';
import {StarRatingComponent} from './star-rating/star-rating.component';
import {UploaderComponent} from './uploader/uploader.component';
import {
  LeftMenuNavigatorComponent
} from './left-menu-navigator/left-menu-navigator.component';
import {TransactionDetailsComponent} from './transaction-details/transaction-details.component';
import {FileUploadFormComponent} from './file-upload-form/file-upload-form.component';

import {ListingComponent} from './listing/listing.component';
import {ListingBootstrapComponent} from './listing-bootstrap/listing-bootstrap.component';
import {BoxesListingComponent} from './boxes-listing/boxes-listing.component';
import {GroupListingComponent} from './group-listing/group-listing.component';
import {ListSortingComponent} from './list-sorting/list-sorting.component';
import {FooPopupComponent} from './foo-popup/foo-popup.component';
import {FooPopupService} from './foo-popup/foo-popup.service';

import {CountriesListComponent} from './shared/countries/countries-list/countries-list.component';
import {GeneralSettingsComponent} from './shared/general-settings/general-settings.component';
import {AddCountryComponent} from './shared/countries/add-country/add-country.component';
import {AddStep1DoneFormComponent} from './shared/app-info-settings/add-step1-done-form/add-step1-done-form.component';
import {
  AddDocumentTypesFormComponent
} from './shared/app-info-settings/add-document-types-form/add-document-types-form.component';
import {AppInfoSettingsComponent} from './shared/app-info-settings/app-info-settings.component';
import {EditStepsFormComponent} from './shared/countries/country-details/edit-steps-form/edit-steps-form.component';
import {AddStep2DoneFormComponent} from './shared/app-info-settings/add-step2-done-form/add-step2-done-form.component';
import {CountryDetailsComponent} from './shared/countries/country-details/country-details.component';
import {
  AddIntroductionFormComponent
} from './shared/app-info-settings/add-introduction-form/add-introduction-form.component';
import {DisplayChallengesDialogComponent} from './shared/display-challenges-dialog/display-challenges-dialog.component';


import {TransactionDetailsService} from './services/transaction-details.service';

import {SharedModule, AppComponentsConfig} from 'common-framework/shared-module';

import {
  MAT_COLOR_FORMATS,
  NGX_MAT_COLOR_FORMATS
} from '@angular-material-components/color-picker';
import { DialogService } from './services/dialog.service';
import {FooTabsComponent} from './foo-tabs/foo-tabs.component';
import {PageTopComponent} from './page-top/page-top.component';

const components = [
  NewsBoxComponent,
  ListingComponent,
  ListingBootstrapComponent,
  StarRatingComponent,
  UploaderComponent,
  BoxesListingComponent,
  FooPopupComponent,
  GroupListingComponent,
  AddCountryComponent,
  CountriesListComponent,
  CountryDetailsComponent,
  EditStepsFormComponent,
  AppInfoSettingsComponent,
  AddDocumentTypesFormComponent,
  AddIntroductionFormComponent,
  AddStep1DoneFormComponent,
  AddStep2DoneFormComponent,
  GeneralSettingsComponent,
  LeftMenuNavigatorComponent,
  ListSortingComponent,
  TransactionDetailsComponent,
  FileUploadFormComponent,
  FooTabsComponent,
  PageTopComponent
];

@NgModule({
  declarations: [
    ...components,
    DisplayChallengesDialogComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    SharedModule,
    FooFrameworkModule,
  ],
  providers: [
    {provide: MAT_COLOR_FORMATS, useValue: NGX_MAT_COLOR_FORMATS}
  ],
  exports: [
    ...components,
    SharedModule
  ]
})
export class SharedModulesModule {
  static forRoot(componentConfig: AppComponentsConfig = {}): ModuleWithProviders<SharedModulesModule> {
    return {
      ngModule: SharedModulesModule,
      providers: [
        importProvidersFrom(SharedModule.forRoot()),
        TransactionDetailsService,
        DialogService,
      ]
    };
  }

  static forChild(): ModuleWithProviders<SharedModulesModule> {
    return {
      ngModule: SharedModulesModule,
      providers: [
        importProvidersFrom(SharedModule.forChild()),
        DialogService,
      ]
    };
  }
}
